'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _actions = require('../customer/actions');

var _actions2 = _interopRequireDefault(_actions);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions3 = require('linksoft/core/actions');

var _actions4 = _interopRequireDefault(_actions3);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _message2 = require('linksoft/message');

var _message3 = _interopRequireDefault(_message2);

var _linksoftAlbatros = require('linksoft-albatros');

var _menuResponsive = require('../initializers/menuResponsive');

var _menuResponsive2 = _interopRequireDefault(_menuResponsive);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _ContactForm = require('./components/cartDetail/step3/ContactForm');

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _exceptionTypes = require('../exception-types');

var _exceptionTypes2 = _interopRequireDefault(_exceptionTypes);

var _cartInitialState = require('./containers/cart-initial-state');

var _storageProvider = require('../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

var _CouponResponseExtension = require('./CouponResponseExtension');

var _CouponResponseExtension2 = _interopRequireDefault(_CouponResponseExtension);

var _analyticsPusherLibrary = require('../analyticsPusherLibrary');

var _noHtml = require('../validation/noHtml');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App', 'Common', 'Validation');
var cartService = _abp2.default.services.api.cartB2c;

var onChangeSubmitHandle = 0;

var cartActions = {
    setStep: function setStep(step) {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.step === step) return;

            if (step > 2) {
                // require deliveryTypeId and paymentTypeId
                if (!(typeof state.cart.deliveryTypeId === 'number' && typeof state.cart.paymentTypeId === 'number')) {
                    step = 2;
                }
            }
            if (step > 1) {
                // require items in cart
                if (state.cart.items.length === 0 && state.cart.giftItems.length === 0) {
                    step = 1;
                }
            }
            dispatch({ type: _actionTypes2.default.CHANGE_STEP, step: step });
            _analyticsPusherLibrary.analyticsPusherLibrary.pushCheckout(step, state.cart).then(function () {});
        };
    },

    setCoupon: function setCoupon(code) {
        var replacePrevious = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return function (dispatch, getState) {
            dispatch({ type: _actionTypes2.default.SETTING_COUPON });

            var selectedFp = getSelectedFreeProduct(getState());
            cartService.setCoupon(code, replacePrevious, selectedFp).done(function (result) {
                result.couponCode = code;

                switch (result.reason) {
                    case _linksoftAlbatros.CouponResponse.Success:
                        dispatch(cartActions.loadData({ id: 1 }, true)).then(function () {
                            dispatch({ type: _actionTypes2.default.COUPON_SET, couponRefusedReason: null });
                        });
                        break;

                    case _linksoftAlbatros.CouponResponse.AnotherCodeAlreadySet:
                        _message3.default.confirm(Resx.App.ShouldReplaceCouponConfirmMessage, Resx.Messages.ConfirmTitle).then(function () {
                            return dispatch(cartActions.setCoupon(code, true));
                        }).catch(function () {});
                        dispatch({ type: _actionTypes2.default.COUPON_SET });
                        break;

                    case _linksoftAlbatros.CouponResponse.CodeNotFound:
                        _notify2.default.warn(Resx.App.InvalidCouponCode);
                        dispatch({
                            type: _actionTypes2.default.COUPON_SET,
                            couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.App.InvalidCouponCode })
                        });
                        break;

                    case _CouponResponseExtension2.default.CouponAlreadyUsed:
                        _notify2.default.warn(Resx.App.CouponAlreadyused);
                        dispatch({
                            type: _actionTypes2.default.COUPON_SET,
                            couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.App.CouponAlreadyused })
                        });
                        break;

                    case _CouponResponseExtension2.default.CouponMinPriceNotReached:
                        var warnMsg = Resx.App.CouponCanBeUsedFromPrice.replace('%minprice%', result.couponMinPrice + ' ' + Resx.App.Currency);
                        _notify2.default.warn(warnMsg);
                        dispatch({ type: _actionTypes2.default.COUPON_SET, couponRefusedReason: (0, _extends3.default)({}, result, { text: warnMsg }) });
                        break;
                }
            }).fail(function () {
                dispatch({
                    type: _actionTypes2.default.COUPON_SET,
                    couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.Messages.CouponIsNotValid })
                });
                _notify2.default.error(Resx.Messages.CouponIsNotValid);
            });
        };
    },

    removeCoupon: function removeCoupon(isVoucher) {
        return function (dispatch, getState) {
            if (!isVoucher) isVoucher = false;

            var selectedFp = getSelectedFreeProduct(getState());
            cartService.removeCoupon(isVoucher, selectedFp).done(function (result) {
                dispatch(cartActions.update(result));
            }).fail(function (response) {
                console.error(response);
            });
        };
    },

    changeAmount: function changeAmount(item) {
        item.amount = item.amount + ''; // ensure amount is always string
        return function (dispatch) {

            _promise2.default.resolve(item.amount === '0').then(function (remove) {
                return remove ? _message3.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle) : true;
            }).then(function () {
                return dispatch((0, _extends3.default)({ type: _actionTypes2.default.CHANGE_AMOUNT }, item));
            }).then(function () {
                if (onChangeSubmitHandle) {
                    clearTimeout(onChangeSubmitHandle);
                }
                onChangeSubmitHandle = setTimeout(function () {
                    dispatch(cartActions.submitChanges(item, false));
                }, 400);
            }).catch(function () {});
        };
    },

    removeItem: function removeItem(item) {
        return function (dispatch) {
            _message3.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
                return dispatch(cartActions.submitChanges(item, false));
            }).catch(function () {});
        };
    },

    createItemsArray: function createItemsArray(item, state) {
        var items = (0, _isObject2.default)(item) ? [item] : (0, _values2.default)(state.cart.changes).map(function (v) {
            return {
                giftId: v.giftId,
                productId: v.productId,
                amount: v.amount
            };
        });
        return items;
    },

    // submit
    submitChanges: function submitChanges(item) {
        var noRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing || cartActions.checkZeroNewAmount(state, item)) return;

            var items = cartActions.createItemsArray(item, state);
            dispatch({ type: _actionTypes2.default.SUBMIT_CHANGES, items: items });

            if (!_abp2.default.session) {
                (0, _ajax2.default)({
                    url: '/Account/AuthenticateAnonymous',
                    method: 'post',
                    contentType: 'application/json',
                    dataType: 'json'
                }).done(function (res) {
                    $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                    if (noRefresh) {
                        cartActions.updateChangesNoRefresh(item, items, state, dispatch);
                    } else {
                        cartActions.submitChangesInternal(items, state, dispatch);
                    }
                }).fail(function (err) {
                    console.error('Error in Anonymous authentication', err);
                });
            } else {
                if (noRefresh) {
                    cartActions.updateChangesNoRefresh(item, items, state, dispatch);
                } else {
                    cartActions.submitChangesInternal(items, state, dispatch);
                }
            }
        };
    },

    updateChangesNoRefresh: function updateChangesNoRefresh(item, items, state, dispatch) {
        var replacements = [{ original: item.productId, replacement: item.productName }];

        cartService.updateCartNoRefresh(items, state.cart.isCompact).done(function (result) {
            if (result.success && (result.updateResults || []).length > 0) {
                cartActions.updateCartNoRefreshSuccess(state, item, dispatch, result.updateResults[0]);
            } else {
                cartActions.showMessageComplex(result, Resx.Common.Warning, Resx.Messages.CannotAddToCart, 'warn', replacements);
                console.warn('Update Cart No refresh error', result);
                dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            }
        }).fail(function (result) {
            cartActions.showMessageComplex(result, Resx.Common.Error, Resx.Common.AjaxError, 'error', replacements);
            console.error('Update Cart No refresh error', result);
            dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
        });
    },

    submitChangesInternal: function submitChangesInternal(items, state, dispatch) {
        var compact = state.cart.isCompact || false;
        if (items.length === 1) {
            compact = items[0].takeCompact || false;
        }

        cartService.update(items, compact).done(function (result) {
            cartActions.dispatchUpdateAndCache(dispatch, result);

            if (items.length === 1) {
                var changedItem = result.items[0];
                // result is immediately gathered value from server 
                var item = result.items.find(function (i) {
                    return i.id === changedItem.id;
                });
                // state.cart - is client value = previous state
                var cartItem = state.cart.items.find(function (i) {
                    return i.id === changedItem.id;
                });
                _analyticsPusherLibrary.analyticsPusherLibrary.addItemToCart(item, state, item.amount - cartItem.amount).then(function () {});
            }
        }).fail(function (e) {
            dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            _notify2.default.error(Resx.Messages.CannotAddToCart);
        });
    },

    showMessageComplex: function showMessageComplex(result, title, defaultText, severity, replacements) {
        if (!result || !result.updateResults || result.updateResults.length < 0) {
            _common2.default.showMessageOrNotify(severity, false, title, defaultText);
            return;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(result.updateResults), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var updateRes = _step.value;

                var jointMessage = updateRes.messages && updateRes.messages.length > -1 ? updateRes.messages.join(',') : defaultText;
                jointMessage = _common2.default.batchReplace(jointMessage, replacements);
                _common2.default.showMessageOrNotify(severity, !!updateRes.showMessagesAsPopup, title, jointMessage);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },

    dispatchUpdateAndCache: function dispatchUpdateAndCache(dispatch, cartResult, updateOnly) {
        dispatch({ type: _actionTypes2.default.UPDATE, cart: cartResult });
        cartResult.notifyMessages = [];
        _storageProvider2.default.setValueSession(_storageProvider2.default.cartCacheKey, cartResult, updateOnly);
    },

    checkZeroNewAmount: function checkZeroNewAmount(state, item) {
        // allow to add only if amount of currently added product is > 0 and also is not currently in cart
        if (!state || !state.cart || !state.cart.items || !item) return true;
        var productInCart = state.cart.items.some(function (i) {
            return ((i.productId || -1) === item.productId || (i.cartItemId || -1) === item.cartItemId) && i.amount > 0;
        });
        return item.amount === 0 && !productInCart;
    },

    updateCartNoRefreshSuccess: function updateCartNoRefreshSuccess(state, item, dispatch, updateResult) {
        var updatedCart = (0, _extends3.default)({}, state.cart);
        updatedCart.changedProductId = item.productId;

        if (!updateResult.changes.some(function (ur) {
            return ur.productId === item.productId;
        }) && !item.giftId) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(updateResult.messages || [Resx.Messages.CannotAddToCart]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _message = _step2.value;

                    _notify2.default.warn(_message);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        } else {
            cartActions.addItemToCart(updatedCart.items, item, true);
            cartActions.addItemToCart(updatedCart.itemAmounts, item);
            cartActions.sumTotalPrice(updatedCart);

            var cartChangeObject = { productId: item.productId, customerId: item.customerId };
            var key = (0, _linksoftAlbatros.getCartChangeKey)(cartChangeObject);
            delete updatedCart.changes[key];

            cartActions.dispatchUpdateAndCache(dispatch, updatedCart);
            _analyticsPusherLibrary.analyticsPusherLibrary.addItemToCart(item, state).then(function () {});
        }
    },

    addItemToCart: function addItemToCart(collection, item, addPriceObject) {
        var foundCartItem = collection.find(function (it) {
            return it.productId === item.productId;
        });
        if (!foundCartItem) {
            if (addPriceObject) {
                var price = item.finalPrice || item.price || 0;
                item.price = {
                    amount: item.amount,
                    unitPrice: { finalPrice: price },
                    totalPrice: { finalPrice: price * item.amount }
                };
            }
            collection.push(item);
        } else if (item.amount === 0) {
            collection.splice(collection.indexOf(foundCartItem), 1);
        } else {
            foundCartItem.amount = item.amount;
        }
    },

    sumTotalPrice: function sumTotalPrice(cart) {
        var finalPrice = 0,
            finalPriceNoVat = 0;

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = (0, _getIterator3.default)(cart.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var item = _step3.value;

                var unitPrice = typeof item.price === 'number' ? { finalPrice: item.price } : item.price.unitPrice;
                finalPrice += unitPrice.finalPrice * item.amount;
                var priceNoVat = unitPrice.finalPriceWithoutVat || (item.resultPrice || {}).finalPriceWithoutVat || 0;
                finalPriceNoVat += priceNoVat * item.amount;
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        cart.totalPrice.finalPrice = finalPrice;
        cart.totalPrice.finalPriceWithoutVat = finalPriceNoVat;
        cart.totalVat = finalPrice - finalPriceNoVat;
    },

    setCartNote: function setCartNote(note) {
        return function (dispatch) {
            var noteError = (0, _noHtml.containsHtmlTag)(note) ? Resx.Validation.NoHtml_ValidationError : null;
            dispatch({ type: _actionTypes2.default.CHANGE_NOTE, note: note, noteError: noteError });
        };
    },

    // update cart state (usually comes from server)
    update: function update(cart) {
        return function (dispatch) {
            cartActions.dispatchUpdateAndCache(dispatch, cart, true);
            if (!cart.anonymous) {
                dispatch(_actions2.default.setMode(_ContactForm.FormMode.registered));
            }
        };
    },

    // load cart data from server (used for initialization)
    loadData: function loadData(cart, forceServerReload) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.LOAD_DATA });

            if (cart && cart.id) {
                var cachedCart = _storageProvider2.default.getValueSession(_storageProvider2.default.cartCacheKey, 5);

                if (cachedCart && !forceServerReload && (cart.itemAmounts || []).length === (cachedCart.itemAmounts || []).length) {
                    dispatch({ type: _actionTypes2.default.UPDATE, cart: cachedCart });
                    // for menu responsive recalculate
                    setTimeout(_menuResponsive2.default, 200);
                } else {
                    return cartService.getCart().done(function (result) {
                        cartActions.dispatchUpdateAndCache(dispatch, result);
                        // for menu responsive recalculate
                        setTimeout(_menuResponsive2.default, 200);
                    }).fail(function () {
                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                    });
                }
            } else {
                var cartDef = _cartInitialState.cartDefinition;
                // if there is no cart id - no need to perform callback
                cartActions.dispatchUpdateAndCache(dispatch, cartDef);
                setTimeout(_menuResponsive2.default, 200);
            }
        };
    },

    empty: function empty() {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing) {
                return;
            }
            _message3.default.confirm(Resx.Messages.ConfirmClearCart, Resx.Messages.ConfirmTitle, function (isConfirmed) {
                if (isConfirmed) {
                    cartService.clear(state.cart.isCompact).done(function (result) {
                        cartActions.dispatchUpdateAndCache(dispatch, result);
                    }).fail(function () {
                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                    });
                }
            });
        };
    },

    sendOrder: function sendOrder() {
        return function (dispatch, getState) {
            var state = getState();

            if (state.cart.noteError) return;
            if ((state.cart.processing || state.cart.sendingOrder) && !state.cart.customerChangeRoundtrip) {
                return;
            }
            dispatch({ type: _actionTypes2.default.ORDERING });
            dispatch(_actions2.default.saveContact()).then(function () {
                var _state$cart = state.cart,
                    note = _state$cart.note,
                    hasShoppingConditionsConsent = _state$cart.hasShoppingConditionsConsent;


                if (!hasShoppingConditionsConsent) {
                    return cartActions.resolveOrderSendError({ message: Resx.Messages.NoShoppingConditionsConsent }, dispatch, getState, 3);
                }
                // set to session storage for later usage by GA
                _storageProvider2.default.setValue(_storageProvider2.default.previousCartPersistedKey, state, false);

                if (note !== null) {
                    cartService.saveOptions((0, _linksoftAlbatros.getCartOptions)(state.cart)).done(function () {
                        return createOrder();
                    }).fail(function () {
                        dispatch({ type: _actionTypes2.default.OPTIONS_SAVING_FAILED });
                        _notify2.default.error(Resx.Common.AjaxError);
                    });
                } else {
                    return createOrder();
                }
            }).catch(function (err) {
                var errSafe = err || { code: 0 };
                if (errSafe.reauthenticateAnonymousCustomer && !state.cart.customerChangeRoundtrip) {
                    // the call failed because the current customer is anonymous and already has an order
                    // we need to force the change of the customer entity and retry the order (just once to be safe)
                    (0, _ajax2.default)({
                        url: '/Account/AuthenticateAnonymous?forceChange=true',
                        method: 'post',
                        contentType: 'application/json',
                        dataType: 'json'
                    }).done(function (res) {
                        $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                        dispatch({ type: _actionTypes2.default.CUSTOMER_CHANGE_ROUNDTRIP });
                        return cartActions.sendOrder()(dispatch, getState);
                    });
                } else if (errSafe.code === _exceptionTypes2.default.InvalidZipCode) {
                    return cartActions.resolveOrderSendError(errSafe, dispatch, getState, 2);
                } else if (errSafe.code === _exceptionTypes2.default.ProductOutOfStock) {
                    return cartActions.resolveOrderSendError(errSafe, dispatch, getState, 1);
                } else {
                    cartActions.processSendOrderGenericError(dispatch, errSafe);
                }
            });
        };
    },

    changeConsentValue: function changeConsentValue(value, isReviewConsent) {
        return function (dispatch, getState) {
            var state = getState();
            if (isReviewConsent) {
                state.cart.hasCustomerReviewConsent = value;
                state.customer.contact.hasCustomerReviewConsent = value;
            } else {
                state.cart.hasShoppingConditionsConsent = value;
                state.customer.contact.hasShoppingConditionsConsent = value;
            }
            return dispatch({ type: _actionTypes2.default.CONSENT_CHANGE, state: state });
        };
    },

    resolveOrderSendError: function resolveOrderSendError(errSafe, dispatch, getState, stepNumber) {
        _message3.default.error(errSafe.message);
        dispatch({ type: _actionTypes2.default.ORDER_FAILED, error: errSafe });
        return cartActions.setStep(stepNumber)(dispatch, getState);
    },

    processSendOrderGenericError: function processSendOrderGenericError(dispatch, errSafe) {
        // have to scroll to first error
        (0, _linksoftAlbatros.scrollToTop)();

        dispatch({ type: _actionTypes2.default.ORDER_FAILED, error: errSafe });
        if (!errSafe.suppressError) {
            var messageText = errSafe.message || Resx.Messages.OrderFailure;

            if (errSafe.code === _exceptionTypes2.default.AmountNotAvailable) {
                _message3.default.error(messageText).then(function () {
                    location.reload();
                });
            } else {
                _message3.default.error(messageText);
            }
        }
    },

    updateDeliveryType: function updateDeliveryType(deliveryTypeId, pickupPlaceId, pickupPlaceName, phoneCountryCode) {
        return function (dispatch, getState) {
            var cart = getState().cart;
            cart.deliveryTypeId = deliveryTypeId;
            cart.phoneCountryCode = phoneCountryCode;
            cart.pickupPlaceId = pickupPlaceId;
            cart.pickupPlaceName = pickupPlaceName;
            cart.deliveryPrice = cartActions.getDeliveryPrice(cart, deliveryTypeId);
            cart.processing = false;
            return dispatch({ type: _actionTypes2.default.DELIVERY_CHANGE, cart: cart });
        };
    },

    updatePaymentType: function updatePaymentType(paymentTypeId) {
        return function (dispatch, getState) {
            var cart = getState().cart;
            cart.paymentTypeId = paymentTypeId;
            cart.deliveryPrice = cartActions.getDeliveryPrice(cart, null, paymentTypeId);
            cart.processing = false;
            return dispatch({ type: _actionTypes2.default.PAYMENT_CHANGE, cart: cart });
        };
    },

    getDeliveryPrice: function getDeliveryPrice(cart, deliveryTypeId, paymentTypeId) {
        var price = 0;
        deliveryTypeId = deliveryTypeId || cart.deliveryTypeId;
        paymentTypeId = paymentTypeId || cart.paymentTypeId;

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = (0, _getIterator3.default)(cart.deliveryTypes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var dtc = _step4.value;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(dtc.collection), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var deliveryType = _step5.value;

                        if (deliveryType.id === deliveryTypeId) {
                            price = deliveryType.deliveryPrice;
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        var paymentType = cart.paymentTypes.find(function (pt) {
            return pt.id === paymentTypeId;
        });
        if (paymentType) {
            price += paymentType.paymentPrice;
        }

        return price;
    },


    updateFreeProducts: function updateFreeProducts(addId, removeId) {
        return function (dispatch, getState) {
            var products = (0, _linksoftAlbatros.getCartOptions)(getState().cart).selectedFreeProducts || [];
            if (addId) products.push({ discountCampaignFreeProductId: addId, amount: 1 });

            var newProducts = products.filter(function (p) {
                return p && p.discountCampaignFreeProductId !== removeId;
            });
            var cart = getState().cart;
            cart.selectedFreeProducts = [].concat((0, _toConsumableArray3.default)(newProducts));
            _storageProvider2.default.setValue(_storageProvider2.default.sharedKeys.freeProducts, newProducts);
            return dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
        };
    },

    restoreDeliveryAndFreeItems: function restoreDeliveryAndFreeItems() {
        return function (dispatch, getState) {
            var cart = getState().cart;
            cart.selectedFreeProducts = _storageProvider2.default.getValue(_storageProvider2.default.sharedKeys.freeProducts, 15);
            cart.selectedDeliveryType = _storageProvider2.default.getValueSession(_storageProvider2.default.sharedKeys.deliveryType, 60);
            return dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
        };
    },

    resolveUnavailableFreeProduct: function resolveUnavailableFreeProduct(cart, response, messageTemplate, dispatch) {
        // gather selected product name
        var availablefreeProducts = cart.freeProducts.reduce(function (a, b) {
            return a.concat(b);
        }).freeProducts;
        var removedProducts = response.removeFreeDcProducts || [];
        var selectedFp = availablefreeProducts.filter(function (fp) {
            return removedProducts.indexOf(fp.discountCampaignId) >= 0;
        });
        messageTemplate.text = (Resx.Messages.SelectedFreeProductNotAvailable || '|freeItem| N/A').replace('|freeItem|', '"' + selectedFp.map(function (p) {
            return p.productName;
        }).join(', ') + '"');
        messageTemplate.title = Resx.App.FreeProduct;
        sweetAlert(messageTemplate);

        // remove selected free product from available products (state)
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = (0, _getIterator3.default)(cart.freeProducts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var fpGroup = _step6.value;

                fpGroup.freeProducts = fpGroup.freeProducts.filter(function (x) {
                    return removedProducts.indexOf(x.discountCampaignId) < 0;
                });
            }
            // remove selected free product from selected products (state)
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        cart.selectedFreeProducts = cart.selectedFreeProducts.filter(function (sfp) {
            return removedProducts.indexOf(sfp.discountCampaignFreeProductId) < 0;
        });
        dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
        // for case, if response contain not user friendly (diagnostics) message
        if (response.message) {
            console.error(response.result.message);
        }
    },

    savePaymentDeliveryFreeProducts: function savePaymentDeliveryFreeProducts(cart) {
        var _this = this;

        return function (dispatch) {
            var allOptions = (0, _linksoftAlbatros.getCartOptions)(cart);
            // get backed up free products from local storage, there is danger, that pickup place may clean them
            var cachedFreeProducts = _storageProvider2.default.getValue(_storageProvider2.default.sharedKeys.freeProducts, 10);
            if (cachedFreeProducts && cachedFreeProducts.length > 0) {
                cart.selectedFreeProducts = cachedFreeProducts;
                dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
                allOptions.selectedFreeProducts = cachedFreeProducts;
            }

            cartService.saveOptionsNoReload(allOptions).done(function (response) {
                var messageTemplate = {
                    text: Resx.App.ErrorsWhileSaving,
                    type: 'warning',
                    title: Resx.App.ErrorsWhileSaving,
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: Resx.Common.Confirm
                };

                if (!response) {
                    console.error('No response or response result');
                    sweetAlert(messageTemplate);
                } else {
                    // make buttons available
                    dispatch({ type: _actionTypes2.default.SET_PROCESSING, processing: false });

                    if (!response.success) {
                        switch (response.failtype) {
                            case 'UnavailableFreeProduct':
                                _this.resolveUnavailableFreeProduct(cart, response, messageTemplate, dispatch);
                                break;
                            case 'OutOfStock':
                                _message3.default.warn(response.message, response.usermessage).then(function () {
                                    return window.location.reload();
                                });
                                break;
                        }
                    }
                }
            });
        };
    },

    saveOptions: function saveOptions(options) {
        return function (dispatch, getState) {
            return new _promise2.default(function (resolve) {
                dispatch({ type: _actionTypes2.default.OPTIONS_CHANGED, options: options });
                saveCurrentOptions(dispatch, getState);
                return resolve();
            });
        };
    },

    setProcessing: function setProcessing(processing) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.SET_PROCESSING, processing: processing });
        };
    },

    updateMidCartVisibility: function updateMidCartVisibility(visible) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.MID_CART_VISIBILITY, midCartVisibility: visible });
            // Do not show mobile floating footer. Beware, it is not present on desktop.
            _common2.default.addRemoveClass('.mobile-floating-footer', 'hidden', visible, false);
        };
    }
};

function createOrder() {
    var order = (0, _ajax2.default)({
        type: 'POST',
        url: (0, _urls2.default)('createOrder')
    });
    order.done(function () {
        _storageProvider2.default.clearValueSession(_storageProvider2.default.cartCacheKey);
    });
    return order;
}

function saveCurrentOptions(dispatch, getState) {
    if (optionsChangingHandler) clearTimeout(optionsChangingHandler);
    optionsChangingHandler = setTimeout(function () {
        var _getState = getState(),
            cart = _getState.cart;

        var optionsVersion = cart.optionsVersion,
            savingOptionsVersion = cart.savingOptionsVersion;


        if (savingOptionsVersion) {
            // already saving options
            saveCurrentOptions(dispatch, getState);
            return;
        }

        // write down version we are saving right now, do not let concurrent requests
        dispatch({ type: _actionTypes2.default.OPTIONS_SAVING, version: optionsVersion });
        optionsChangingHandler = 0;

        var allOptions = (0, _linksoftAlbatros.getCartOptions)(cart);
        cartService.saveOptions(allOptions).done(function (result) {
            dispatch({ type: _actionTypes2.default.OPTIONS_SAVED, version: optionsVersion });
            cartActions.dispatchUpdateAndCache(dispatch, result);
        }).fail(function () {
            dispatch({ type: _actionTypes2.default.OPTIONS_SAVING_FAILED });
            _notify2.default.error(Resx.Common.AjaxError);
        });
    }, 500);
}

function getSelectedFreeProduct(state) {
    var selectedFreeProducts = state.cart.selectedFreeProducts;

    return selectedFreeProducts && selectedFreeProducts.length > 0 ? selectedFreeProducts[0].discountCampaignFreeProductId : null;
}

var optionsChangingHandler = 0;

_actions4.default.add('cart', cartActions);

exports.default = cartActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/actions.js
// module id = 43
// module chunks = 0 2